import { EmployerStatus } from "./types";

export const EmployerStatusText: Record<EmployerStatus, string> = {
  [EmployerStatus.CREATING]: "Sedang Dibuat",
  [EmployerStatus.SUBMITTED]: "Menunggu Verifikasi",
  [EmployerStatus.IN_REVIEW]: "Sedang Ditinjau",
  [EmployerStatus.REVISION_REQUESTED]: "Perlu Revisi",
  [EmployerStatus.VERIFIED]: "Terverifikasi",
  [EmployerStatus.ACTIVE]: "Aktif",
  [EmployerStatus.REJECTED]: "Ditolak",
};
